module.exports = __webpack_public_path__ + "img/22@2x.8b0b317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/22@2x.png
// module id = qrp+
// module chunks = 0